<template>
    <div>
        <img v-if="user.profile_photo_url && !profile_photo_error && profile_photo_loaded"
            class="rounded-full bg-gray-50" :class="size" :src="user.profile_photo_url"
            @error="profile_photo_error = true" @load="profile_photo_loaded = true" :alt="user.name" />
        <span v-if="!user.profile_photo_url || profile_photo_error || !profile_photo_loaded"
            class="inline-flex items-center justify-center rounded-full bg-gray-900" :class="size">
            <span class="text-sm font-medium text-white">{{
                user.name.substring(0,
                    1).toUpperCase() }}</span>
        </span>
    </div>

</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'size-8'
        }
    },
    created() {
        // console.log(this.user)
    },
    data() {
        return {
            profile_photo_error: false,
            profile_photo_loaded: true
        }
    }
}

</script>
